<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.back')"
        :icon="error ? 'mdi-alert' : 'mdi-page-previous'"
        @press="press"
    />
</template>

<style scoped>

</style>